module.exports = __webpack_public_path__ + "static/media/SetupBadge.66d4d50b.svg";